// extracted by mini-css-extract-plugin
module.exports = {"leftAlign":"Title_leftAlign__mYh6r","container":"Title_container__ZSvj4","delimiter":"Title_delimiter__drMeE"};